import { MODAL_FROM_CONTEXTS } from 'store/ui/actions'
import CheckRowCount from 'components/forms/CheckRowCount'

export const AuthorRelationshipTypes = ({
  toggleFilter,
  toggleModal,
  filters: {
    selfCite,
    independent
  },
  counts,
  fullReport = true,
  upgradeReport
}) => {
  const handleToggle = section => {
    if (!fullReport) {
      toggleFilter('showMobile', false)
      toggleModal(upgradeReport ? 'upgrade' : 'login', true, MODAL_FROM_CONTEXTS.REPORT_FILTER)
      return
    }
    toggleFilter(section)
  }

  return (
    <div>
      <CheckRowCount
        text='Self Cite'
        count={counts.selfCite}
        checked={!!selfCite}
        toggle={() => handleToggle('selfCite')}
      />
      <CheckRowCount
        text='Independent'
        count={counts.independent}
        checked={!!independent}
        toggle={() => handleToggle('independent')}
      />
    </div>
  )
}

export default AuthorRelationshipTypes
